import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { Router } from '@angular/router';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-create-tournament',
  templateUrl: './create-tournament.component.html',
  styleUrls: ['./create-tournament.component.scss']
})
export class CreateTournamentComponent implements OnInit {
  //@ViewChild('datepicker', { static: false }) private _picker: BsDatepickerDirective;
  @ViewChild('startDatePicker', { static: false }) private _startDatePicker: BsDatepickerDirective;
  @ViewChild('endDatePicker', { static: false }) private _endDatePicker: BsDatepickerDirective;
  onShowPicker(event: any, pickerType: string) {
    const dayHoverHandler = event.dayHoverHandler;
    const pickerInstance = pickerType === 'start' ? this._startDatePicker : this._endDatePicker;

    const hoverWrapper = (hoverEvent: any) => {
      const { cell, isHovered } = hoverEvent;

      if (isHovered && /iPad|iPhone|iPod/.test(navigator.platform) && 'ontouchstart' in window) {
        (pickerInstance as any)._datepickerRef.instance.daySelectHandler(cell);
      }

      return dayHoverHandler(hoverEvent);
    };

    event.dayHoverHandler = hoverWrapper;
  }
  tournamentName = '';
  userId = '';
  startDate = '';
  endDate = '';
  inviteCode = '';
  link = '';
  tournamentCreated = false;
  tournamentId = '';
  
  bsConfig: Partial<BsDatepickerConfig>;
  constructor(private readonly coreService: CoreService, 
    private readonly toast: ToastrService,
    private readonly router: Router,
    private gaService: GaService,
    private readonly authService: AuthService, 
    private translate: TranslateService) {
    this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 11, 31),
      showWeekNumbers: false
    };
  }

  ngOnInit() {
    this.userId = this.authService.getUserId();
  }

  onSubmit(form) {
    form.submitted = false;
    this.coreService.createTournament(this.userId, this.tournamentName, this.startDate, this.endDate).then((response:any) => {
      if (response.messageKey == 'tournament-name-already-exists') {
        this.toast.error(this.translate.instant('tournament-name-already-exists'), this.translate.instant('error'));
      } else {
        this.gaService.emitEvent('new trournaments', 'Register Screen');
        this.toast.success(this.translate.instant('tournament-created-successfully'), this.translate.instant('success'));
        this.tournamentCreated = true;
        this.inviteCode = response.result.uniqueCode;
        this.tournamentId = response.result.tournamentId;
        this.link = 'https://' + window.location.host + '?id=' + response.result.tournamentId;
      }
      
    })
  }

  copyCode(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.toast.success(this.translate.instant('copied'));
  }

  goToTournament() {
    localStorage.setItem('tournamentid', this.tournamentId);
    localStorage.setItem('tournamentName', this.tournamentName);
    this.router.navigate(['/ranking']);
  }
  
}




